import { render } from "./PetList.vue?vue&type=template&id=56d46688"
import script from "./PetList.vue?vue&type=script&lang=js"
export * from "./PetList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__